module.exports = "pegasus/assets/theme5/medium/7.jpg";